import { getCatalogIdForSpotifyId } from './composerRegistry';

export interface ArtistLike {
  id?: string | null;
  uri?: string | null;
}

export const extractSpotifyArtistId = (
  artist: ArtistLike | string | undefined | null
): string | null => {
  if (!artist) return null;

  if (typeof artist === 'string') {
    return artist;
  }

  if (artist.id) {
    return artist.id;
  }

  const uri = artist.uri ?? undefined;
  if (!uri) return null;

  const segments = uri.split(':');
  return segments.length ? segments[segments.length - 1] : null;
};

export const resolveArtistRoute = (
  artist: ArtistLike | string | undefined | null,
  composerIds?: ReadonlySet<string>
): string => {
  const targetId = extractSpotifyArtistId(artist);
  if (!targetId) {
    return '/artist';
  }

  const isComposer = composerIds?.has(targetId);
  if (!isComposer) {
    return `/artist/${targetId}`;
  }

  const catalogId = getCatalogIdForSpotifyId(targetId);
  return `/composer/${catalogId ?? targetId}`;
};
